import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FormText from "./form/formText.component";
import FormTitleInput from "./form/formTitleInput.component";
import ContainerBox from "./common/containerBox.component";
import { changeTitle } from "../actions/index";
import { stateProps } from "../types";

const Title: React.FC = () => {
  const dispatch = useDispatch();

  const title = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.title
  );

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;
    dispatch(changeTitle(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"01"} title={"What is your title?"} />
        <FormTitleInput onInputChange={onInputChange} title={title} />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Title;
